import React, { useRef } from "react";
import "../styles/hero.css";
import Navbar from "../components/NavBar";
import AboutMe from './AboutMe';
import HomePage from './HomePage';
import Projects from './Projects';
import ContactMe from './ContactMe';
import Publications from "./Publications";

export default function Hero() {
  const homeSection = useRef(null);
  const projectSection = useRef(null);
  const aboutSection = useRef(null);
  const contactSection = useRef(null);
  const publicationSection = useRef(null);
  
  return (
    <>
      <div className="hero">
        <div className="hero-navbar">
          <Navbar
            homeSectionRef={homeSection}
            projectSectionRef={projectSection}
            aboutSectionRef={aboutSection}
            contactSectionRef={contactSection}
            publicationRef={publicationSection}
          />
        </div>

        <div className="hero-homepage" ref={homeSection}>
          <HomePage
            homeSectionRef={homeSection}
            projectSectionRef={projectSection}
            aboutSectionRef={aboutSection}
            contactSectionRef={contactSection}
            publicationRef={publicationSection}
          />
        </div>

        <div className="hero-aboutme" ref={aboutSection}>
          <AboutMe />
        </div>

        <div className="hero-projects" ref={projectSection}>
          <Projects />
        </div>

        <div className="hero-publications" ref={publicationSection}>
          <Publications />
        </div>

        <div className="hero-contact" ref={contactSection}>
          <ContactMe />
        </div>
      </div>
    </>
  );
}
